import InputTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/InputTitle';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';
import type { SectionItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/sectionItemAttributes';

import FlipLayout from './FlipLayout';
import MobileDisplay from './MobileDisplay';

const GlobalSettings = ({
  defaultAttributes,
  item,
  onChange,
}: ComponentSettingsTab<SectionItemAttributes>) => {
  const settingProps = { defaultAttributes, item, onChange };

  return (
    <>
      <InputTitle
        boxProps={{ mb: 3 }}
        id={`checkboxSetting-${item.id}`}
        label={__('Global settings')}
      />
      {item?.children?.length && item.children.length > 1 && (
        <FlipLayout {...settingProps} />
      )}
      <MobileDisplay {...settingProps} />
    </>
  );
};

export default GlobalSettings;
